import React from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import MaskedInput from "react-text-mask"
import subdomainMaskArr from "./subdomainMaskArr"

const MaskedSudDomain = ({ classes, inputRef, ...other }) => {
  return (
    <MaskedInput
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null)
      }}
      mask={subdomainMaskArr}
      guide={false}
      showMask={false}
      keepCharPositions
    />
  )
}

export default withStyles(styles)(MaskedSudDomain)



// WEBPACK FOOTER //
// ./src/components/MaskedSubDomain/index.jsx